import React from 'react';
import {Icon} from 'react-icons-kit';
import {checkmarkCircled} from 'react-icons-kit/ionicons/checkmarkCircled';
import Text from 'common/components/Text';
import Heading from 'common/components/Heading';
import Button from 'common/components/Button';
import Container from 'common/components/UI/Container';
import SectionWrapper, {
  PricingArea,
  InnerWrapper,
  PricingCard,
} from './pricingPolicy.style';
import {Link} from 'gatsby';

const PricingPolicy = () => {

  const plans = [
    {
      id: 'web', title: 'Web Shop', description: '', features: [
        {id: 'feature1', text: 'Unbegrenzte Bestellungen'},
        {id: 'feature2', text: 'Vorbestellungen akzeptieren'},
        {id: 'feature3', text: 'Kostenloses SSL-Zertifikat'},
        {id: 'feature4', text: 'EPOS-spezifische Integration'},
      ], price: 59
    }
  ];

  return (
    <SectionWrapper id="pricing">
      <Container>
        <h2>
          <Heading content={"Preisliste"}/>
        </h2>
        <PricingArea>
          <InnerWrapper>
            {plans.map((item) => (
              <PricingCard key={`${item.id}`}>
                <div className="card-header">
                  <Heading as="h3" content={item.title}/>
                  <Text content={item.description}/>
                </div>
                <div className="card-body">
                  <ul className="feature-list">
                    {item.features.map((feature) => (
                      <li key={`${feature.id}`}>
                        <Icon icon={checkmarkCircled}/> {feature.text}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="card-footer">
                  <strong>
                    <span>{item.price} €</span> / Monat
                  </strong>
                  <Link to={`/contact-us/?${item.id}=1`}>
                    <Button
                      title="Abonniere"
                    />
                  </Link>
                </div>
              </PricingCard>
            ))}
          </InnerWrapper>
        </PricingArea>
      </Container>
    </SectionWrapper>
  );
};

export default PricingPolicy;
